<!--Can't use multiple ng-content in a component, so need to do this :-(-->
<ng-template #fieldLabel><ng-content></ng-content></ng-template>
<div class="label" *ngIf="value">
  <ng-template [ngTemplateOutlet]="fieldLabel"></ng-template>
</div>

<div class="value">{{ value }}<ng-template *ngIf="!value" [ngTemplateOutlet]="fieldLabel"></ng-template></div>
<!--we may need to display the hint text, but currently there is no 'mat-hint' in use in the application -->
